import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';

import Navbar from 'client/components/Navbar';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';
import SrAdminEditListingForm from 'client/components/SrAdminEditListingForm';

import { admin as listingFieldgroupAdmin } from 'server/models/Listing/fieldgroups';

import {
  SR_API_ACTION_GET_LISTING_BY_ID,
  SR_API_ACTION_GET_LISTING_BY_MLS_NUMBER,
} from 'api/actionTypes';

import { SCREEN_ID_ADMIN_EDIT_LISTING } from 'client/constants/screenIds';
import { USER_ROLE_ADMIN } from 'common/userRoles';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withApiState from 'client/helpers/withApiState';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';

@withScrollToTop
@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withApiState({
  listingByIdApiState: {
    action: SR_API_ACTION_GET_LISTING_BY_ID,
  },
  listingByMlsNumberApiState: {
    action: SR_API_ACTION_GET_LISTING_BY_MLS_NUMBER,
  },
})
@withScreenId(SCREEN_ID_ADMIN_EDIT_LISTING)
@branch()
class AdminListingEditPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Admin | Sunroom Rentals',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      listing: null,
    };
  }

  _onLoadListing = ({ listingId, mlsNumber }) => {
    const { dispatch } = this.props;
    let apiRequest;
    if (listingId) {
      apiRequest = dispatch(postWithState, {
        action: SR_API_ACTION_GET_LISTING_BY_ID,
        payload: {
          listingId: listingId,
          fieldgroup: listingFieldgroupAdmin,
        },
      });
    } else if (mlsNumber) {
      apiRequest = dispatch(postWithState, {
        action: SR_API_ACTION_GET_LISTING_BY_MLS_NUMBER,
        payload: {
          mlsNumber: mlsNumber,
          fieldgroup: listingFieldgroupAdmin,
        },
      });
    }

    if (apiRequest) {
      apiRequest.then((listing) => {
        this.setState({ listing });
      });
    }
  };

  render() {
    const { listingByIdApiState, listingByMlsNumberApiState, dispatch } = this.props;

    const { listing } = this.state;

    return (
      <div className="page-admin">
        <div className="adminContainer">
          <Navbar redirectLogoTo="/admin" />

          <div className="section">
            <Formik
              initialValues={{ listingId: '', mlsNumber: '' }}
              onSubmit={this._onLoadListing}
              render={() => (
                <Form>
                  <Field type="number" name="listingId" placeholder="Listing ID" />
                  <Field type="text" name="mlsNumber" placeholder="MLS number" />
                  <ButtonDeprecated
                    theme={BUTTON_THEME_BLUE}
                    type="submit"
                    disabled={
                      listingByIdApiState.inProgress || listingByMlsNumberApiState.inProgress
                    }
                  >
                    {listing ? 'Loaded' : 'Load'}
                  </ButtonDeprecated>
                </Form>
              )}
            />
          </div>

          {listing && (
            <div className="section">
              <SrAdminEditListingForm listing={listing} dispatch={dispatch} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

AdminListingEditPage.displayName = 'AdminListingEditPage';

export default AdminListingEditPage;
